import { styled } from "@mui/material";
import AddLink from "controls/global/add-link";
import { useSignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import React from "react";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import { PERMISSIONS } from "utils/data/enum";

const LinkContainer = styled("div")({
  marginRight: "auto",
});

function AddSignatureLink() {
  const { showAdd } = useSignatureDefaultDialogProvider();
  const [{ profileSettings }] = useProfileSettingsCache();

  const permissionCodes = profileSettings?.userPermissionItemTypes as string[];
  const hasAddSignatureAccess = permissionCodes?.includes(PERMISSIONS.SIGNATURES_ADD);
  return (
    <LinkContainer>
      <AddLink
        disabled={!hasAddSignatureAccess}
        onClick={showAdd}
      >
        Add Default Signature
      </AddLink>
    </LinkContainer>
  );
}

export default AddSignatureLink;
